/* eslint-disable newline-before-return */
import { useCallback } from "react";

export const useClipboard = () => {
  const fallbackCopy = (text: string) => {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.zIndex = "-1";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  };

  const copyText = useCallback(async (text: string) => {
    if (!text) throw new Error("EMPTY");
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
      return fallbackCopy(text);
    } catch {
      return false;
    }
  }, []);

  return { copyText };
};
